module.exports = __webpack_public_path__ + "static/media/placeholder.85b020b8.jpg";